import { render, staticRenderFns } from "./relatorioEdit.vue?vue&type=template&id=391854e0&scoped=true"
import script from "./relatorioEdit.vue?vue&type=script&lang=js"
export * from "./relatorioEdit.vue?vue&type=script&lang=js"
import style0 from "./relatorioEdit.vue?vue&type=style&index=0&id=391854e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391854e0",
  null
  
)

export default component.exports